// extracted by mini-css-extract-plugin
export default {"reasonDropdown":"CancelContractModal_reasonDropdown__f0YOj","modalContainer":"CancelContractModal_modalContainer__AEfn8"};